module.exports = __webpack_public_path__ + "img/finallogo.c21252a0.png";